export default "__VITE_ASSET__DZVLpnrD__"